const config = {
  apiUrl: 'https://az-api.locumspace.co/api/v1/',
  userDashboardUrl: 'https://dashboard.locumspace.co/account/signin',
  websiteUrl: 'https://locumspace.co',
};

export default config;

// https://dev-api.locumspace.co